import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import androidTheme from './theme/androidTheme';
import Dashboard from './pages/Dashboard/Dashboard';
import Portfolio from './pages/Portfolio/Portfolio';
import Insights from './pages/Insights/Insights';
import Login from './pages/Auth/Login';
import Register from './pages/Auth/Register';
import ForgotPassword from './pages/Auth/ForgotPassword';
import ResetPassword from './pages/Auth/ResetPassword';
import Settings from './pages/Settings/Settings';
import AddCrypto from './pages/AddCrypto/AddCrypto';
import EditCrypto from './pages/EditCrypto/EditCrypto';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import Profile from './pages/Profile/Profile';
import WelcomeScreen from './pages/Auth/Onboarding/WelcomeScreen';
import LanguageSelectScreen from './pages/Auth/Onboarding/LanguageSelectScreen';
import WelcomeCapitalScreen from './pages/Auth/Onboarding/WelcomeCapitalScreen';
import WelcomeCompleteScreen from './pages/Auth/Onboarding/WelcomeCompleteScreen';
import { Tools, WealthSimulator, Market } from './pages/Tools';

function App() {
  return (
    <ThemeProvider theme={androidTheme}>
      <CssBaseline />
      <Router>
        <Routes>
          {/* Routes publiques */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/onboarding/language" element={<LanguageSelectScreen />} />
          <Route path="/onboarding/welcome" element={<WelcomeScreen />} />
          <Route path="/onboarding/capital" element={<WelcomeCapitalScreen />} />
          <Route path="/onboarding/complete" element={<WelcomeCompleteScreen />} />
          
          {/* Routes protégées sans layout (style Android) */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/portfolio" element={<ProtectedRoute><Portfolio /></ProtectedRoute>} />
          <Route path="/insights" element={<ProtectedRoute><Insights /></ProtectedRoute>} />
          <Route path="/tools" element={<ProtectedRoute><Tools /></ProtectedRoute>} />
          <Route path="/tools/wealth-simulator" element={<ProtectedRoute><WealthSimulator /></ProtectedRoute>} />
          <Route path="/tools/market" element={<ProtectedRoute><Market /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
          <Route path="/add-crypto" element={<ProtectedRoute><AddCrypto /></ProtectedRoute>} />
          <Route path="/edit-crypto" element={<ProtectedRoute><EditCrypto /></ProtectedRoute>} />
          <Route path="/profile" element={<Profile />} />
          
          {/* Route par défaut */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
